module.exports = __webpack_public_path__ + "img/logoflexxs_B&W.6636010a.png";